import { useSelector } from "react-redux";
import { getDataFromLocalStorage } from "utils/helpers";

const usePermission = (moduleName) => {
  const { userDetails } = useSelector((state) => ({
    userDetails: state.student.userDetails,
  }));

  const userType = getDataFromLocalStorage("user_type");

  // Default: full access for all non-admin users
  let permissions = {
    view: "1",
    create: "1",
    update: "1",
    delete: "1",
  };

  // Apply permission restrictions only for user types 0, 1, or 6
  if (['0', '1', '6'].includes(userType)) {
    permissions =
      userDetails?.role_data?.find(
        (item) => item?.permission_name === moduleName
      )?.sub_permission || {};
  }

  return {
    viewAccess: permissions.view || "0",
    createAccess: permissions.create || "0",
    updateAccess: permissions.update || "0",
    deleteAccess: permissions.delete || "0",
  };
};

export default usePermission;

// import { useSelector } from "react-redux";

// const usePermission = (moduleName) => {
//   const { userDetails } = useSelector((state) => ({
//     userDetails: state.student.userDetails,
//   }));

//   const permissions =
//     userDetails?.role_data?.find(
//       (item) => item?.permission_name === moduleName
//     )?.sub_permission || {};

//   return {
//     viewAccess: permissions.view || "0",
//     createAccess: permissions.create || "0",
//     updateAccess: permissions.update || "0",
//     deleteAccess: permissions.delete || "0",
//   };
// };

// export default usePermission;
